import { render } from "./Publications.vue?vue&type=template&id=0e4183fd&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"

import "./Publications.vue?vue&type=style&index=0&id=0e4183fd&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4183fd"]])

export default __exports__